import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@auth';
import { AppService } from '@core/services/app.service';

/**
 * OIDC Authorization Code redirect target. By the time this route activates, the keycloak-js
 * APP_INITIALIZER has already exchanged the code parameter for tokens and AuthService has
 * synced them to localStorage. This component just runs the post-login chain (Firebase logins,
 * userLoggedIn$ event, navigation to returnUrl/home/setup wizard).
 */
@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit, OnDestroy {

  constructor(
    private appService: AppService,
    private authService: AuthService
  ) {
    this.appService.handleNavState('expanded');
    this.appService.handleBodyControls(true);
    // The tokens are already synced by this point, so the toolbar and nav menu would otherwise render
    // (and be clickable) on top of this loading screen while the post-login chain is still running —
    // letting the user open a page mid-login (Bug 27489). Show the loading screen on its own instead.
    this.appService.enableFullLayout();
  }

  ngOnInit(): void {
    this.authService.completeLoginAfterCallback();
  }

  ngOnDestroy(): void {
    this.appService.disableFullLayout();
  }
}